{#if !hasAcceptedCookies}
    <div class="cookie" transition:fly={{y:100}}>
        <div>This Website uses cookies to ensure you get the best experience on our Website - we use cookies to distinguish you from other users of our Website. Cookies placed by the Website cannot access, read or modify any other data on a computer.</div>
        <div class="right"><button on:click={acceptCookies} class="ok">OK</button></div>
    </div>
{/if}

<style type="text/scss">
.cookie{
    color:#0365a0;
    position:fixed;
    bottom:0px;
    left:0px;
    width:100%;
    background-color:white;
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    z-index:4;
    & > div{
        padding:20px 20px;
    }
    .right{
        display:flex;
        justify-content:center;
        align-items:center;
    }
    .ok{
        background-color:var(--success);
    }
}
</style>

<script>
import { fly } from 'svelte/transition'

let hasAcceptedCookies = false
const acceptCookies = () => {
    hasAcceptedCookies = true
}
</script>